// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__c4c4r","icon":"style_icon__38ch0"};